export default "__VITE_ASSET__90ca0dc0__"